import { useAuthContext } from "../../../../context/AuthContext";
import { useLanguageContext } from "../../../../context/LanguageContext";
import useCalamityToolCreateRouteConfig from "../../../../routes/configs/calamities/tools/CalamityToolCreateRouteConfig";
import useCalamityToolEditRouteConfig from "../../../../routes/configs/calamities/tools/CalamityToolEditRouteConfig";
import DataTable, { useDataTable } from "../../main/DataTable";
import useBasicColumnConfig from "../../main/config/column/default/BasicColumnConfig";
import useTimestampColumnConfig from "../../main/config/column/default/TimestampColumnConfig";
import DataTableConfig from "../../main/config/dataTable/DataTableConfig";
import useCreateHeaderActionConfig from "../../main/config/headerAction/default/CreateHeaderActionConfig";
import useDeleteRowActionConfig from "../../main/config/rowAction/default/DeleteRowActionConfig";
import useEditRowActionConfig from "../../main/config/rowAction/default/EditRowActionConfig";

function CalamityToolsDataTable() {
  const authContext = useAuthContext();
  const { translate } = useLanguageContext();

  //Create the datatable config
  const config = new DataTableConfig("calamity_tools");

  //Set the datatable fetch info
  config.setFetchRequest("calamity_tools");

  //Set the datatable order by
  config.setOrderBy("order");
  config.setOrderDirection("asc");

  //Set the datatable header
  config.setHeader(translate("eva.main.entities.calamity_tools"));

  //Set the datatable columns
  config.setColumns([
    useBasicColumnConfig("name").setLockActive(true),
    useBasicColumnConfig("order"),
    useTimestampColumnConfig("created_at"),
    useTimestampColumnConfig("updated_at"),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig("calamity_tool", useCalamityToolEditRouteConfig()),
    useDeleteRowActionConfig("calamity_tool").setDisabled(
      () => !authContext.hasPermission("calamities.update")
    ),
  ]);

  //Set the datatable header actions
  config.setHeaderActions([
    useCreateHeaderActionConfig(
      "calamity_tool",
      useCalamityToolCreateRouteConfig()
    ),
  ]);

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default CalamityToolsDataTable;
